import { createAction } from '@reduxjs/toolkit';
import { RecordOf } from 'immutable';
import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import { UserInfoProps } from './userInfoTypes';

export const getUserInfo = createAction('GET_USER_INFO', getPayloadCreator());
export const getUserInfoSuccess = createAction(
  'GET_USER_INFO_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<UserInfoProps>>(),
);
export const getUserInfoFailure = createAction('GET_USER_INFO_FAILURE', errorPayloadCreator);

export const userRegisterMeForBeta = createAction(
  'USER_REGISTER_ME_FOR_BETA',
  getPayloadCreator<{ clientId: string }>(),
);
export const userRegisterMeForBetaSuccess = createAction('USER_REGISTER_ME_FOR_BETA_SUCCESS');
export const userRegisterMeForBetaFailure = createAction('USER_REGISTER_ME_FOR_BETA_FAILURE', errorPayloadCreator);

export const userUnregisterMeForBeta = createAction(
  'USER_UNREGISTER_ME_FOR_BETA',
  getPayloadCreator<{ clientId: string }>(),
);
export const userUnregisterMeForBetaSuccess = createAction('USER_UNREGISTER_ME_FOR_BETA_SUCCESS');
export const userUnregisterMeForBetaFailure = createAction('USER_UNREGISTER_ME_FOR_BETA_FAILURE', errorPayloadCreator);

export const setAlwaysMFA = createAction('SET_ALWAYS_MFA', getPayloadCreator());
export const setAlwaysMFASuccess = createAction('SET_ALWAYS_MFA_SUCCESS', getPayloadCreator<RecordOf<UserInfoProps>>());
export const setAlwaysMFAFailure = createAction('SET_ALWAYS_MFA_FAILURE', errorPayloadCreator);
